// UUID format: lowercase hexadecimal UUID (8-4-4-4-12 characters)
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

// Date format: YYYYMMDD (8 digits)
export const DATE_REGEX = /^\d{8}$/;

// Time format: HHmm (24-hour format, 00:00 to 23:59)
export const TIME_REGEX = /^([01][0-9]|2[0-3])[0-5][0-9]$/;

// Activity ID format: 8 alphanumeric characters
export const ACTIVITY_ID_REGEX = /^[0-9a-zA-Z]{8}$/;

// Booking ID format: 8 alphanumeric characters
export const BOOKING_ID_LENGTH = 8;
export const BOOKING_ID_REGEX = /^[0-9a-zA-Z]{8}$/;

// Salon date format: UUID:YYYYMMDD
export const SALON_ID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
export const SALON_DATE_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}:\d{8}$/;

// eslint-disable-next-line no-useless-escape
export const SALON_SUBDOMAIN_SLUG_REGEX = /^[a-z](?:[a-z0-9\-]{2,58}[a-z0-9])$/;

// Expert time format: UUID:HHmm
export const EXPERT_TIME_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}:([01][0-9]|2[0-3])[0-5][0-9]$/;

// Expert time or ID format: UUID or UUID:HHmm (time portion is optional)
export const EXPERT_TIME_OR_ID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(:([01][0-9]|2[0-3])[0-5][0-9])?$/;

// Expert salon format: UUID:UUID (expertId:salonId)
export const EXPERT_SALON_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

// Email format: stricter validation aligned with Zod's z.email() - requires domain with at least one dot
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Phone number format: digits and common phone characters (+, -, (, ), space, /, .); empty allowed (optional field)
export const GUEST_PHONE_REGEX = /^[0-9+\-(). /]*$/;

// Slot format: HHmm (4 digits)
export const SLOT_REGEX = /^\d{4}$/;

// DateSlot format: YYYYMMDDHHmm (4 digits)
export const DATE_SLOT_REGEX = /^\d{12}$/;
